export default __webpack_public_path__ + "static/spitz-phones-mobile-92cde49714af24b499e086d211820107.jpg";